import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    authtoken: null,
    admin_acclist: [],
    admin_branchcodes: {},
    admin_selacc: null,
    ws_login_status: 0,  // 0: logged out, 1: logged in, 2: login error, 3: login busy
    server_time_delta: 0,
    last_activity: 0
  },
  mutations: {
    set_authtoken(state, newtoken) {
      state.authtoken = newtoken
      if (state.last_activity === 0) {
        state.last_activity = Math.floor(Date.now() / 1000)
      }
    },
    set_server_time_delta(state, server_time) {
      state.server_time_delta = server_time - Math.floor(Date.now() / 1000)
    },
    set_admin_acclist(state, newacclist) {
      state.admin_acclist = newacclist.slice()
    },
    set_admin_branchcodes(state, new_branch_codes) {
      state.admin_branchcodes = Object.assign({}, new_branch_codes)
    },
    set_admin_selacc(state, newsel) {
      state.admin_selacc = newsel
    },
    set_ws_login_status(state, val) {
      state.ws_login_status = val
    },
    set_activity(state) {
      state.last_activity = Math.floor(Date.now() / 1000)
    }
  },
  getters: {
    auth_token: state => state.authtoken,
    auth_data: (state, getters) => state.authtoken ? JSON.parse(atob(getters.auth_token.split('.')[1])) : null,
    auth_user: (state, getters) => getters.auth_data ? getters.auth_data.user : null,
    auth_exp: (state, getters) => getters.auth_data ? getters.auth_data.exp : null,
    auth_desc: (state, getters) => getters.auth_data ? getters.auth_data['description'] : null,
    auth_branch_code: function (state, getters) {
      if (getters.auth_data == null) {
        return ''
      }
      let acc = getters.auth_user
      if (acc === 'admin') {
        acc = state.admin_selacc
        if (!acc) { return null }
        return state.admin_branchcodes[acc]
      }
      return getters.auth_data['branch_code']
    }
  }
})
